import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

/*
320px — 480px: Mobile devices.
481px — 768px: iPads, Tablets.
769px — 1024px: Small screens, laptops.
1025px — 1200px: Desktops, large screens.
1201px and more — Extra large screens, TV.

Write your "default" CSS statements to be for small screens
Only use media queries for larger screens. There's usually no need for a max-width media query.


// we can't (at least directly) use css variables for media queries.
$mobile: 320px;
$tablet: 481px;
$laptop: 769px;
$desktop: 1025px;
$tv: 1201px;

 */

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  public mobile$ = this.breakpointObserver.observe('(max-width: 480px)').pipe(
    map((breakpointState: BreakpointState) => breakpointState.matches),
    shareReplay(1),
  );

  public tablet$ = this.breakpointObserver.observe('(max-width: 768px)').pipe(
    map((breakpointState: BreakpointState) => breakpointState.matches),
    shareReplay(1),
  );

  public smallScreen$ = this.breakpointObserver
    .observe('(max-width: 1024px)')
    .pipe(
      map((breakpointState: BreakpointState) => breakpointState.matches),
      shareReplay(1),
    );

  public bp1$ = this.breakpointObserver.observe('(max-width: 1234px)').pipe(
    map((breakpointState: BreakpointState) => breakpointState.matches),
    shareReplay(1),
  );

  public bp2$ = this.breakpointObserver.observe('(max-width: 836px)').pipe(
    map((breakpointState: BreakpointState) => breakpointState.matches),
    shareReplay(1),
  );

  constructor(private breakpointObserver: BreakpointObserver) {}
}
